import { SelectInput } from "@/components/admin/select-input";
import { cn } from "@/lib/utils";
import type { DotConfig } from "./colorConfig";
import { getDotColor } from "./colorConfig";

type ColorSelectInputProps = Omit<React.ComponentProps<typeof SelectInput>, "optionText"> & {
    colorConfig: DotConfig;
};

/** SelectInput with a colored dot per choice, driven by a value->color map (see colorConfig.ts). */
export const ColorSelectInput = ({ colorConfig, ...props }: ColorSelectInputProps) => {
    return (
        <SelectInput
            {...props}
            optionText={(choice: any) => (
                <span className="flex items-center gap-2">
                    <span
                        className={cn(
                            "w-2 h-2 rounded-full shrink-0",
                            getDotColor(colorConfig, choice?.id)
                        )}
                    />
                    {choice?.name ?? choice?.id}
                </span>
            )}
        />
    );
};
